<div class="flex flex-1 flex-col">
	<div class="border-b border-grey-lighter pb-4 mb-2">
		<h4>Add an undertaking</h4>
		<p class="mt-2">Please enter the following details for the undertaking</p>
	</div>

	<div class="mb-2">
		<app-container title="Details" type="dark">
			<div class="flex">
				<app-input
					type="text"
					label="Subject of undertaking"
					name="subject"
					class="mb-5"
					[(ngModel)]="undertaking.subject"
				></app-input>
				<app-date-picker
					label="Follow up date"
					name="followUp"
					class="ml-2"
					[(ngModel)]="undertaking.followUp"
				></app-date-picker>
			</div>

			<div class="w-min">
				<app-checkbox
					label="Fulfilled"
					[(ngModel)]="undertaking.fulfilled"
					(ngModelChange)="setFulfilled($event)"
				></app-checkbox>
			</div>
			<div
				*ngIf="undertaking.type === 'encumbrance' && undertaking.fulfilled"
				class="flex justify-between items-end mt-4"
				[@openClose]
			>
				<app-input
					type="text"
					label="Discharged by instrument number"
					name="dischargeNumber"
					[(ngModel)]="child.dischargedInstrumentNumber"
				></app-input>
				<app-date-picker
					label="Registered on date"
					name="registeredOn"
					class="ml-2"
					[(ngModel)]="child.registeredOnDate"
				></app-date-picker>
			</div>
		</app-container>
	</div>
	<div
		class="mb-2 mt-2 flex justify-between"
		*ngIf="undertaking.type === 'debt'"
	>
		<p>
			<label class="font-bold">Payee: </label>
			{{ undertaking.child?.payee?.name }}
		</p>
		<p>
			<label class="font-bold">Debt amount: </label>
			{{ undertaking.child?.amount | centsToDollars }}
		</p>
	</div>
	<div class="w-full flex my-2 justify-end">
		<app-radio-group
			[items]="states"
			[(ngModel)]="editing"
			type="compact"
		></app-radio-group>
	</div>

	<app-text-area
		*ngIf="!editing"
		label="Undertaking text"
		name="text"
		[ngModel]="parsedText"
		height="140px"
		disabled
	></app-text-area>
	<app-text-area
		*ngIf="editing"
		label="Undertaking text"
		name="text"
		[(ngModel)]="undertaking.text"
		height="140px"
	></app-text-area>

	<div
		*ngFor="
			let relatedInstrument of undertaking?.relatedInstruments | keyvalue;
			let i = index
		"
		class="mt-2"
	>
		<app-text-area
			*ngIf="!editing"
			label="Related instrument ({{ i + 1 }})"
			name="text"
			[ngModel]="
				relatedInstrumentsTextareaStates[relatedInstrument.key].parsedText
			"
			height="140px"
			disabled
		></app-text-area>
		<app-text-area
			*ngIf="editing"
			label="Related instrument ({{ i + 1 }})"
			name="text"
			[(ngModel)]="undertaking.relatedInstruments[relatedInstrument.key].text"
			height="140px"
		></app-text-area>
	</div>

	<div class="flex justify-between mt-5">
		<app-button btn="tertiary" (click)="cancelModal()">Cancel</app-button>
		<app-button (click)="saveModal()">Save</app-button>
	</div>
</div>
